import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import ProductsView from "./ProductsView";
import BaseAdminView from "./BaseAdminView";
import CommerceUserView from "./CommerceUserView";
import StagesManager from "../../components/StagesManager";
import Cookies from "universal-cookie";
import { chooseFontColor, conditionalWidth } from "../../utils/useful";
// import ViewBlog from "./database/ViewBlog";
// import DatabaseAdminView from "./database/DatabaseAdminView";
// import HttpServices from "../../utils/Http.services";
// import UserPerspectivePageViewer from "./UserPerspectivePageViewer";
// import PageViewer from "../PageViewer";
// import PagesStackNavigator from "../PagesStackNavigator";
import CollectionBaseUserView from "./CollectionBaseUserView";
import { framesConfig } from "../../variables/framesStatics";


class DatabaseApplet extends React.Component {
    state = {
        colors: {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }
    }
    setData = (key, value, reference, cb) => {
        // console.log('setDataDATABASE')
        if (reference == 'DatabaseApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    componentDidMount() {

        // console.log("componentDidMountfcsdsdC", this.props)
        // console.log(this.props.frames)

        // const cookies = new Cookies();
        // let token = cookies.get('token');
        // if (token) {
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        // } else {
        //     this.waitForId(10)
        //     this.setState({ pageStatus: 401 })
        // }

        this.waitForId(10)



        let data = {}
        data.applet = this.props.applet

        this.init()

        // console.log("this.props.applet",this.props.applet)
        // console.log("this.props.frames",this.props.frames)

        // HttpServices.request('getFrames', data, (fetchResult, fetchError) => {

        //     if (fetchError) {
        //         return
        //     }

        // this.setState({ frames, framesSections, currentFrameName })
        // })

    }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.windowData//.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        // console.log('commeerceeeeee', prevProps, this.props.windowData, this.props.lastSelected);
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('commeerceeeeee');
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }


        if ((JSON.stringify(this.props.frames) != JSON.stringify(prevProps.frames))) {
            this.init()
        }
    }



    init = () => {



        let frames = this.props.frames

        // console.log("frames",this.props.applet,frames)
        // let framesSections = [
        //     { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
        //     { key: 'pages', name: '{{lang}}Pages', addNew: 'addPage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // ]

        if (Array.isArray(frames)) {
            // console.log('this.props.framessl',this.props.frames)
            frames.forEach(element => {
                let frameInfo
                // console.log('element0000',element)
                if (element.mode) {
                    frameInfo = framesConfig[element.mode]
                }
                if (!frameInfo) {
                    frameInfo = framesConfig[element.type]
                }

                if (frameInfo) {
                    Object.entries(frameInfo)?.map(([key, value]) => {
                        element[key] = value
                        if (typeof value == 'string' && value.startsWith('{{')) {
                            let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                            element[key] = element[baseValue]
                        }
                    })
                }

                if (element.type == 'collection' && Array.isArray(element.fields)) {
                    element.fields.forEach(field => {
                        // if (!field.key.includes("values.")) {
                        //     field.key = "values." + field.key
                        // }
                    })
                }
                // if (element.type == 'collection') {
                //     element.key = element._id
                //     element.section = 'collections'
                //     element.pageType = 'collection'
                //     element.fetchUrl = 'getRecords'
                //     element.addUrl = 'postRecord'
                //     element.editUrl = 'updateRecord'
                //     element.removeUrl = 'removeRecord'
                //     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                //     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }

                // }

                // else if (element.type == 'page') {
                //     element.key = element._id
                //     element.section = 'pages'
                //     element.pageType = 'page'
                //     element.fetchUrl = 'getRecords'
                //     element.addUrl = 'postRecord'
                //     element.editUrl = 'postRecord'
                //     element.removeUrl = 'removeRecord'
                //     element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                //     element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                //     element.fields.forEach(field => {
                //         if (!field.key.includes("values.")) {
                //             field.key = "values." + field.key
                //         }
                //     })
                // }
            })
        }

        // console.log("frames, ", frames)
        // console.log('frammeesss',frames)

        let currentFrameName = frames ? frames[0]?.name : null
        this.setState({ frames, currentFrameName })


    }


    waitForId = (leftAttempt) => {

        this.checkDefaultTab()

        // if (this.props.user?.info?._id) {

        //     this.checkDefaultTab()
        // } else {
        //     setTimeout(() => {
        //         if (leftAttempt != 0) {
        //             this.waitForId(leftAttempt - 1)
        //         } else {
        //             // this.props.actions.logoutUser()
        //             this.setState({ pageStatus: 401 })
        //         }
        //     }, 500);
        // }
    }





    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        // console.log('rootRefd', this.props.route)
        // console.log('pathnamedatabase', pathname)

        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }

        // console.log(def)




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            // console.log('page', pageType, def);
            this.setState({ oldData: this.props.windowData }, () => {


                this.setState({ path: def, pageType }, () => {
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }

    updateFrames = (frame) => {

        // console.log('*updateFrames')

        this.props.frameUpdateActions()

        // if (!Array.isArray(frame)) {
        //     frame = [frame]
        // }
        // let frames = this.state.frames
        // // console.log('framefirst', frame, this.props.frameUpdateActions)
        // for (let i = 0; i < frame.length; i++) {

        //     if (this.props.frameUpdateActions) {
        //         this.props.frameUpdateActions(frame[i], 'append')
        //     }
        //     // console.log('frame[i].type', frame[i].type)
        //     let frameInfo = framesConfig[frame[i].type]

        //     if (frameInfo) {
        //         Object.entries(frameInfo)?.map(([key, value]) => {
        //             frame[i][key] = value
        //             if (typeof value == 'string' && value.startsWith('{{')) {
        //                 let baseValue = value.replace(/{/g, '').replace(/}/g, '')
        //                 frame[i][key] = frame[i][baseValue]
        //             }
        //         })
        //     }
        //     // console.log('beffirst', JSON.parse(JSON.stringify(frames)))
        //     // console.log('this.props.framessl',this.props.frames)
        //     if (frame[i].type == 'collection' && Array.isArray(frame[i].fields)) {
        //         frame[i].fields.forEach(field => {
        //             // if (!field.key.includes("values.")) {
        //             //     field.key = "values." + field.key
        //             // }
        //         })
        //     }

        //     let found
        //     let cIndex
        //     frames.map((item, index) => {
        //         if (item._id == frame[i]._id) {
        //             found = true
        //             cIndex = index
        //         }
        //     })
        //     if (found) {
        //         frames[cIndex] = frame[i]
        //     } else {
        //         frames.push(frame[i])
        //     }
        //     // console.log('framesUP', frames)
        //     this.setState({ frames })
        // }

    }


    render() {



        let colors = this.state.colors ?? {}
        let applet = this.props.applet

        if (applet?.colorType == 'sameAsHub') {
            if (this.props.user.info?.colors) {
                colors = this.props.user.info.colors
            }
        }

        if (applet?.colorType == "custom" && applet?.colors) {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`



        return (

            <div className={" w-100 h-100 " + (this.props.isDesktop ? "window-content-radius" : "")} style={{ backgroundColor: '#F5F5F5' }}>

                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                    <BaseAdminView updateFrames={this.updateFrames} updateUserSettings={this.props.updateUserSettings}
                        userSettings={this.props.userSettings} stageName={'admin'} isDesktop={this.props.isDesktop}
                        isMobile={this.props.isMobile} addNewWindow={this.props.addNewWindow}
                        permissions={this.props.permissions} baseUrl={[...this.props.baseUrl, 'admin']}
                        frames={this.state.frames} framesSections={this.state.framesSections} colors={colors}
                        language={this.props.language} width={this.props.width} height={this.props.height}
                        lastSelected={this.props.lastSelected} variables={this.props.variables}
                        windowData={this.props.windowData} route={this.props.route} applet={this.props.applet}
                        changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow}
                        goToHub={this.props.goToHub} updateConnectionPermissions={this.props.updateConnectionPermissions}
                        appletAccess={this.props.appletAccess} closeWindow={this.props.closeWindow} setData={this.setData}
                        frameUpdateActions={this.props.frameUpdateActions} automations={this.props.automations} />

                    {/* <PageViewer userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height} */}

                    {/* <PagesStackNavigator
                        stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height} */}

                    <CollectionBaseUserView userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables}
                        colors={colors} frames={this.state.frames} framesSections={this.state.framesSections}
                        changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} />
                    {/* <PageViewer userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} /> */}



                    {/* <PageViewer editMode={false} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} /> */}

                    {/* <UserPerspectivePageViewer stageName={''} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} /> */}
                    {/* <ViewBlog stageName={''} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} language={this.props.language} colors={colors} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} /> */}
                    {/* <DatabaseAdminView stageName={''} baseUrl={[...this.props.baseUrl]} language={this.props.language} removeWindowLink={this.props.removeWindowLink} width={this.props.width} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} goToHub={this.props.goToHub} /> */}

                </StagesManager>

            </div>
        )
    }



}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DatabaseApplet);
